import React from "react";
import { Link } from "react-router-dom";
import "../../styles/vars.scss";
import "../../styles/main.scss";
import "../../styles/compo.scss";
import SvgIcn from "../../data/IconCompo";
import LogoP from "../atoms/LogoP";
import AllPopups from "./AllPopups";
import HomeLeftBar from "./LeftBars/HomeLeftBar";
import { useNavigate } from "react-router-dom";

function LeftBarNav({ children, selectedMode }) {
  const navigate = useNavigate();
  return (
    <div className={`left-bar-hero ${selectedMode && `${selectedMode}-bg`}`}>
      <Link to="/">
        <LogoP
          logo="logo01"
          hoverLogo="logo03"
          logoTypeEn="logotype_en"
          logoTypeJp="logotype_jp"
          className="signup-logo"
        />
      </Link>
      {children ? children : <HomeLeftBar selectedMode={selectedMode} />}
    </div>
  );
}

export default LeftBarNav;
